export default {
	LANG: 'SecureStorage-lang',
	TOKEN: 'SecureStorage-token',
	REFRESH: 'SecureStorage-refresh',
	USER: 'Storage-user',
	PINBUTTONS: 'pinButtons',
	CREDS: 'SecureStorage-creds',
	MESSAGE_TOKEN: 'SecureStorage-message-token',
};

// Secure key can only contain alphanumeric and '.', '-', '_'
